import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

const FeatureMappingViewSchema = z.object({
  key: z.string(),
  keyType: z.enum(["PLAN", "ADDON"]),
  features: z.record(z.string(), z.union([z.boolean(), z.number(), z.string()])),
});

const UpdateFeatureMappingSchema = z.object({
  features: z.record(z.string(), z.union([z.boolean(), z.number(), z.string()])),
});

const EffectiveFeaturesSchema = z.object({
  franchiseId: z.string(),
  features: z.record(z.string(), z.union([z.boolean(), z.number(), z.string()])),
  resolvedFrom: z.array(
    z.object({
      key: z.string(),
      keyType: z.enum(["PLAN", "ADDON"]),
    })
  ),
});

const errorSchema = z.object({ message: z.string() });

export const featureMappingContract = c.router({
  getPlanFeatureMapping: {
    method: "GET",
    path: "/billing/feature-mappings/plans/:planName",
    pathParams: z.object({ planName: z.string() }),
    responses: {
      200: FeatureMappingViewSchema,
      401: errorSchema,
      404: errorSchema,
      500: errorSchema,
    },
    summary: "Get feature mapping for a plan",
  },

  updatePlanFeatureMapping: {
    method: "PUT",
    path: "/billing/feature-mappings/plans/:planName",
    pathParams: z.object({ planName: z.string() }),
    body: UpdateFeatureMappingSchema,
    responses: {
      200: FeatureMappingViewSchema,
      400: errorSchema,
      401: errorSchema,
      404: errorSchema,
      500: errorSchema,
    },
    summary: "Update feature mapping for a plan",
  },

  getAddOnFeatureMapping: {
    method: "GET",
    path: "/billing/feature-mappings/addons/:addOnName",
    pathParams: z.object({ addOnName: z.string() }),
    responses: {
      200: FeatureMappingViewSchema,
      401: errorSchema,
      404: errorSchema,
      500: errorSchema,
    },
    summary: "Get feature mapping for an add-on",
  },

  updateAddOnFeatureMapping: {
    method: "PUT",
    path: "/billing/feature-mappings/addons/:addOnName",
    pathParams: z.object({ addOnName: z.string() }),
    body: UpdateFeatureMappingSchema,
    responses: {
      200: FeatureMappingViewSchema,
      400: errorSchema,
      401: errorSchema,
      404: errorSchema,
      500: errorSchema,
    },
    summary: "Update feature mapping for an add-on",
  },

  getEffectiveFeatures: {
    method: "GET",
    path: "/billing/feature-mappings/effective/:franchiseId",
    pathParams: z.object({ franchiseId: z.string() }),
    responses: {
      200: EffectiveFeaturesSchema,
      401: errorSchema,
      404: errorSchema,
      500: errorSchema,
    },
    summary: "Get the merged effective feature set for a franchise",
  },
});
